var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.357,
    height: 8.5,
    viewBox: "0 0 14.357 8.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_947",
    "data-name": "Groupe 947",
    transform: "translate(16915.678 1719.25)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Ligne_133",
    "data-name": "Ligne 133",
    x2: 14.356,
    transform: "translate(-16915.678 -1719)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_134",
    "data-name": "Ligne 134",
    x2: 14.356,
    transform: "translate(-16915.678 -1715)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_135",
    "data-name": "Ligne 135",
    x2: 14.356,
    transform: "translate(-16915.678 -1711)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.993cd73523309a6ff81c1f364fcc1c52.svg";
export { ForwardRef as ReactComponent };